import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "TumiBackLogin" }
const _hoisted_2 = {
  key: 0,
  class: "TumiLogin"
}
const _hoisted_3 = { class: "TumiForm" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "LogoTumi",
  class: "mb-3 TumiLogoLola"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-white mb-4" }, "Log in to manage your protected projects", -1)
const _hoisted_6 = { class: "d-grid gap-2 mb-2 mb-3" }
const _hoisted_7 = { class: "text-center mt-3" }
const _hoisted_8 = {
  key: 0,
  class: "spinner-border text-light",
  role: "status",
  style: {"position":"inherit"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Password lost?")
const _hoisted_12 = { class: "TumiErrorLogin mt-3" }
const _hoisted_13 = {
  key: 0,
  class: "TumiTextWarning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.Auth)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mail) = $event)),
              placeholder: "Email"
            }, null, 512), [
              [_vModelText, _ctx.mail]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pass) = $event)),
              placeholder: "Password"
            }, null, 512), [
              [_vModelText, _ctx.pass]
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.Login && _ctx.Login(...args))),
                class: "btn btn-info"
              }, "Log in")
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.waiting)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_router_link, { to: {path:'/RetrievePass'} }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.error), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}